import { render, staticRenderFns } from "./RFIs.vue?vue&type=template&id=2c0408b2&scoped=true&"
import script from "./RFIs.vue?vue&type=script&lang=js&"
export * from "./RFIs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0408b2",
  null
  
)

export default component.exports